const tokens = {
  screenxxs: '320px',
  screenxs: '576px',
  screensm: '768px',
  screenmd: '992px',
  screenlg: '1200px',
  screenml: '1366px',
  screenxlg: '1475px',
  screenxxlg: '1600px',
  screenxxxlg: '2500px',
  colorWhite: '#ffffff',
  colorBlack: '#000000',
  colorGradeOU: '#21FC87',
  colorGradeEX: '#76F366',
  colorGradeVG: '#C7EA45',
  colorGradeGD: '#ECC834',
  colorGradeFR: '#EB8632',
  colorGradePR: '#EA4A30',
  colorModal: '#1c1c1c',
  colorNeutral: '#272B2B',
  colorNeutralLight: '#7D7D7D',
  colorNeutralLighest: '#BDBDBD',
  colorRegularLinks: '#4A90E2',
  colorOwnerSweetLine: '#3A65FF',
  colorNonOwnerSweetLine: '#6A0DAD',
};

export default tokens;
